import React from 'react';
import { AccessorFunction } from '../../core/Chart.types';
import { formatCompact } from '../../utils/formatters';
import { DonutCenterDisplay } from './DonutCenterDisplay';

type DonutCenterProps<Datum> = {
  innerRadius: number;
  data: Datum[];
  getValue: AccessorFunction<Datum, number>;
  centerValue?: string | number;
  centerLabel?: string;
};

export const DonutCenter = <Datum,>({ innerRadius, data, getValue, centerValue, centerLabel }: DonutCenterProps<Datum>) => {
  const total = data.reduce((acc, d) => acc + getValue(d), 0);
  const displayValue = centerValue !== undefined ? String(centerValue) : formatCompact.format(total);

  return <DonutCenterDisplay innerRadius={innerRadius} value={displayValue} label={centerLabel} />;
};
